class AdvisorMeeting {
    URL;
    advisor;
    constructor(data) {
        this.URL = data.URL;
        this.advisor = data.advisor;
    }
}
export default AdvisorMeeting;
